import { FormControlLabel, RadioGroup as MuiRadioGroup, Radio } from "@mui/material";
import { FieldWithOptionsProps } from "components/forms/Field";
import { T } from "components/util/t";
import { FormFieldProps } from "../FormField";

interface RadioGroupProps {
    field: FieldWithOptionsProps;
    input: FormFieldProps["input"]
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ field, input }) => {
    return <MuiRadioGroup aria-label={typeof field.label === "string" ? field.label : undefined} role="radiogroup">
        {field.options.map((option, index) => {
            const selected = input.value === option.value;
            return <FormControlLabel
                       key={index}
                       checked={selected}
                       value={option.label}
                       label={<T>{option.label}</T>}
                       aria-checked={selected}
                       onClick={() => input.onChange(option.value)}
                       inputRef={field.inputRef}
                       control={<Radio />}
            />;
        })}
    </MuiRadioGroup>;
};
